import Multiselect from 'vue-multiselect';

/**
 * vue-multiselect decides whether to open the options list above or below by comparing the free space against the window edges only.
 * Our app scrolls inside nested containers (.main-window, .d-panel, modals), so the window math over-reports the space below,
 * and the list opens downward into an area the user cannot see (most visible on short viewports and Firefox on macOS).
 * Overriding the component's method here applies to every usage of the imported component, so all multiselects get the corrected calculation.
 */
Multiselect.methods = Object.assign({}, Multiselect.methods, {
  adjustPosition() {
    if (typeof window === 'undefined' || !this.$el) {
      return;
    }

    // Clamp the visible area by every ancestor that clips its content, not just the window
    let visibleTop = 0;
    let visibleBottom = window.innerHeight;
    for (let ancestor = this.$el.parentElement; ancestor; ancestor = ancestor.parentElement) {
      const overflowY = window.getComputedStyle(ancestor).overflowY;
      if (overflowY !== 'visible') {
        const ancestorRect = ancestor.getBoundingClientRect();
        visibleTop = Math.max(visibleTop, ancestorRect.top);
        visibleBottom = Math.min(visibleBottom, ancestorRect.bottom);
      }
    }

    const elementRect = this.$el.getBoundingClientRect();
    const spaceAbove = elementRect.top - visibleTop;
    const spaceBelow = visibleBottom - elementRect.bottom;
    const hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

    if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === 'below' || this.openDirection === 'bottom') {
      this.preferredOpenDirection = 'below';
      this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
    } else {
      this.preferredOpenDirection = 'above';
      this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
    }
  }
});
